import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "12",
  viewBox: "0 0 14 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.5935 7.04482L13.9997 12L9.45762 9.87029L10.7364 8.99671L8.05404 5.6131L6.99847 6.5196C6.15733 7.24196 4.8802 7.13953 4.16774 6.29257L0.229818 1.61129C-0.121163 1.19405 -0.0636919 0.574414 0.358183 0.227292C0.780058 -0.11983 1.40658 -0.062991 1.75756 0.354245L5.69548 5.03553L6.75105 4.12903C7.60931 3.39196 8.91667 3.51571 9.61799 4.4004L12.3745 7.87761L13.5935 7.04482Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }